import * as React from "react";
import { WithStyles, withStyles } from "@material-ui/styles";
import { Typography, SvgIcon } from "@material-ui/core";
import CheckCircleOutline from "@material-ui/icons/CheckCircleOutline";
import { FormattedMessage } from "react-intl";
import Footer from "../../../../layouts/Footer";
import Header from "../../../../layouts/Header";
import Layout from "../../../../layouts/Layout";
import Link from "../../../../shared/ui/Link";
import { styles } from "./constants/styles";
import messages from "./constants/messages";
import { useAuth } from "../../shared";

type Props = WithStyles<typeof styles>;

const EmailConfirmedPage: React.FC<Props> = (props: Props) => {
  const [isAuth, , , logout] = useAuth();

  if (isAuth) {
    logout();
  }
  
  const { classes } = props;
  return (
    <Layout>
      <Header />
      <div className={classes.root}>
        <SvgIcon fontSize={"large"} color={"primary"}>
          <CheckCircleOutline />
        </SvgIcon>
        <Typography className={classes.header}>
          <FormattedMessage {...messages.header} />
        </Typography>
        <Link active={true} to={`/login/sign-in`}>
          <Typography className={classes.link}>
            <FormattedMessage {...messages.goto} />
          </Typography>
        </Link>
      </div>
      <Footer />
    </Layout>
  );
};

export default withStyles(styles)(EmailConfirmedPage);
